import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-redemption',
  templateUrl: './modal-redemption.component.html',
  styleUrls: ['./modal-redemption.component.scss']
})
export class ModalRedemptionComponent implements OnInit {

  @ViewChild('redemptionModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  reward: any = {};
  myProfile: any = {};
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private utility: UtilitysService,
    private api: ApiService,
    private ngxLoading: NgxUiLoaderService,
  ) { }

  ngOnInit() {
     
    this.modalServ.onRedemption.subscribe(req => {
      
      this.reward = req.reward;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onRedemptionHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  async getMyProfile(){
    this.myProfile = await this.utility.getMyProfile();
  }

  async redeem() {
    this.hide();
    setTimeout(async () => {
      await this.getMyProfile();
      if((this.myProfile.CurrentPoint >= this.reward.PointRedeem) || (this.reward.TotalQty > 0)){
          this.modalServ.onRewardHide.emit();
          this.modalServ.onRedeemInformation.emit({reward: this.reward,myProfile:this.myProfile});
      }
    }, 500);
    
  //   await this.getMyProfile();

  //   const body = {
  //     'rewardId': this.reward.RewardID,
  //     'userId': this.myProfile.UserId
  //   };

  //   this.ngxLoading.start()
  //   this.api.rewardRedemption(body).subscribe((res: any) => {
  //     if(res.Code == 200){
  //       this.modalServ.onRedeemed.emit({status: 'success', message: res.Message});
  //     } else {
  //       this.modalServ.onRedeemedSuccess.emit({status: 'fail', errorMsg: res.Message});
  //     }
  //     this.hide();
  //     this.ngxLoading.stopAll();
  //   }, (err) => {
  //     this.modalServ.onRedeemedSuccess.emit({status: 'fail', errorMsg: 'Internal Error.'});
  //     console.log(err);
  //     this.ngxLoading.stopAll();
  //   });
   }

}
